import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const alagoas: HCConfig = {
         appName: 'Saúde até Você Digital',
         hcId: '',
         isPublic: true,
         uf: 'AL',

         config: {
           trackingId: 'G-9XM1CM7CLY',
           domain: 'app.saudeatevoce.al.gov.br',
           domainKey: 'appAlagoasDomainUrl',
           reactDomainKey: 'appAlagoasDomainReactUrl',
           hcParam: 'alagoas',
           clientDomainHeader: 'alagoas',
           govBrClientId: 'cuidar-piaui-gov-pi',
           supportChatKey:
             'ZWIwNGU2OGUtOTkyOC00MzBlLThmM2YtNjQ2MTliZDlkN2VhOmU4YmM0YjQwMjY4NTQ2ODFkZDM1ZDhmMDI3NWRjYTc4YTU2NTg3MjJjZXNwMDA3MG4yZ0FsQ0dzYzExS0lTOE9uejNtY3dvRmg1SzhvRDJqcWc=',
         },

         assets: {
           logo: HCConfigAssets.mainLogo('alagoas'),
           uploadExternalFilesLogo: HCConfigAssets.uploadExternalFilesLogo('alagoas'),
           preloaderLogo: HCConfigAssets.preloaderLogo('alagoas'),
           favicon: HCConfigAssets.favicon('alagoas'),
         },

         links: {
           site: 'https://app.saudeatevoce.al.gov.br',
           termsOfUse: 'https://saudeatevoce.al.gov.br/termos-de-uso-alagoas.html',
           policyPrivacy: 'https://saudeatevoce.al.gov.br/politica-de-privacidade-alagoas.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.alagoas',
           appstore: 'https://apps.apple.com/us/app/sa%C3%BAde-digital-alagoas/id6751677365',
         },

         dataDeletion: {
           name: 'Saúde até Você Digital',
           slug: 'alagoas',
           agreementTermsUrl: 'https://saudeatevoce.al.gov.br/termo-de-consentimento-exclusao-conta-alagoas.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('alagoas'),
             width: 340,
             height: 149,
           },
         },

         firstAccess: {
           name: 'Saúde até Você Digital',
           city: 'Alagoas',
           slug: 'alagoas',
           emailDomain: '@saudeatevoce.al.gov.br',
           abbreviation: 'al',
           background: 'linear-gradient(45deg, #2d8efb, #034ea2 35%, #023f82)',
           logo: {
             src: HCConfigAssets.firstAccessLogo('alagoas'),
             width: 340,
             height: 150,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/alagoas',
         },

         features: [
           HCConfigFeatures.FIRST_ACCESS_REGISTER,
           HCConfigFeatures.PROCEDURES_APAC_SADT,
           HCConfigFeatures.REFERRAL_GUIDE,
           HCConfigFeatures.REQUEST_ATTENDANCE,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_CNS,
           HCConfigFeatures.ENABLE_FIRST_ACCESS,
           HCConfigFeatures.MANCHESTER_QUESTIONNAIRE,
           HCConfigFeatures.PRISON_SYSTEM_PATIENT_IDENTIFICATION,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],
         rules: [
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF_OR_EMAIL_OR_CNS,
           HCConfigRules.APPOINTMENT_MANAGEMENT,
           HCConfigRules.HC_HAS_CNES,
           HCConfigRules.BLOCK_REGISTRATION_WITH_OUT_OF_STATE_ZIPCODE,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
